module.exports = __webpack_public_path__ + "assets/img/7d27633200aaa0ae4917be32abb6d453.png";